import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../material.module';

import { FileManagementComponent } from './file-management.component';
import { FileManagementService } from './file-management.service';
import { FilesRoutingModule } from './files-routing.module';

@NgModule({
  declarations: [
    FileManagementComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    FilesRoutingModule
  ],
  providers: [
    FileManagementService
  ],
  exports: [
    FileManagementComponent
  ]
})
export class FilesModule { }
